import { CASES } from './constants';

export const updateJobs = (payload) => {
    return { type: CASES.UPDATE_JOBS, payload };
};

export const updateJobsSearchForm = ({ key, data }) => {
    return {
        type: CASES.UPDATE_JOBS_SEARCH_FORM,
        payload: { key, data },
    };
};

export const clearJobs = () => {
    return { type: CASES.CLEAR_JOBS, payload: {} };
};
